import type { FocusedLeadContact, FocusedLeadContactPhone } from '../data';

export type OpenTextTarget = { contact: FocusedLeadContact; phone: FocusedLeadContactPhone };

export function resolveOpenTextTarget(
	contacts: readonly FocusedLeadContact[] | undefined,
	openTextContactId: string | undefined
): OpenTextTarget | undefined {
	if (!openTextContactId || !contacts) return undefined;
	const contact = contacts.find(c => c.id === openTextContactId);
	const phone = contact?.phones[0];
	return contact && phone ? { contact, phone } : undefined;
}
